import type { CommunityBase } from 'models';
import { useTranslation } from 'react-i18next';
import { Classify2LineIcon, DataCard } from 'ui';
import { images } from 'common/utils';

type P = {
  community: CommunityBase;
  getPathToCommunityDetail: (id: string) => string;
  showTag?: boolean;
};

const CommunityCard = ({ community, getPathToCommunityDetail, showTag = true }: P) => {
  const { t } = useTranslation();

  return (
    <DataCard
      className="community-card"
      image={{
        alt: 'Community cover image',
        src: community.coverPhoto?.url ?? images.default.communityCoverPhoto,
      }}
      participantsProperties={{
        count: community.membersCount,
        label: (formattedMembersCount) =>
          t('formattedMembersCount', { count: community.membersCount, formattedCount: formattedMembersCount }),
      }}
      path={getPathToCommunityDetail(community.id)}
      tag={showTag ? { children: 'Community', color: 'green', icon: <Classify2LineIcon /> } : undefined}
      title={community.name}
    />
  );
};

export default CommunityCard;
